import http from 'hub-http/clients/apiClient';
import { prepareForBackend, prepareForPostPut } from '../utils/backendAdaptor';
export class ViewAPI {
  static getView(id, objectTypeId, __clientStorage) {
    return http.get(`sales/v4/views/${objectTypeId}/${id}`);
  }

  /**
   * Updates a view in the backend using the new visualization settings endpoint
   */
  static putView(view, __clientStorage) {
    const backendView = prepareForPostPut(prepareForBackend(view));
    const request = {
      view: backendView,
      visualizationSettingsMap: backendView.visualizationSettingsMap
    };

    // Use new endpoint with wrapped request format
    return http.put(`sales/v4/views/with-visualization-settings/${view.id}`, {
      data: request
    }).then(res => res.persistedView);
  }

  /**
   * Only use for autosaving table config when view is not hubspot defined (index page specific behavior)
   */
  static legacyPutViewDefault({
    id,
    columns,
    state,
    objectTypeId,
    idLabel
  }) {
    const idToUse = idLabel !== null && idLabel !== void 0 ? idLabel : id;
    // FIXME - Generate Sales v3 client type for PUT default-view endpoint and use it here
    return http.put(`/sales/v3/views/default-view/${objectTypeId}/${idToUse}?namespace=NONE`,
    // existing hard-coded namespace as index-page
    {
      data: {
        id: idToUse,
        columns,
        state,
        objectTypeId
      }
    });
  }

  /**
   * Creates a new view in the backend using the new visualization settings endpoint
   */
  static async postView(view, __clientStorage) {
    var _view$visualizationSe;
    const backendView = prepareForBackend(view);

    // Extract viz settings map for new endpoint format
    const visualizationSettingsMap = 'visualizationSettingsMap' in view ? (_view$visualizationSe = view.visualizationSettingsMap) !== null && _view$visualizationSe !== void 0 ? _view$visualizationSe : {} : {};

    // Use new endpoint with wrapped request format
    const backendResponse = await http.post(`sales/v4/views/with-visualization-settings?namespace=${view.namespaceName}`, {
      data: {
        view: backendView,
        visualizationSettingsMap
      }
    });
    return backendResponse.persistedView;
  }

  /**
   * Get a unique name for cloning a view using the backend endpoint that handles naming complexity.
   *
   * @param view - The view to clone
   * @returns The first available unique name for the cloned view
   */
  static getCloneViewName(view) {
    return http.get(`/sales/v4/views/first-available-clone-name/${encodeURIComponent(view.objectTypeId)}/${encodeURIComponent(view.name)}?namespace=${view.namespaceName}`).then(res => res.availableCloneName);
  }
}